<script lang="ts">
    import { onMount } from 'svelte';

    export let center;
    export let vehicles : any[];
    export let bookedCar : any;
    export let distance : number;
    export let language : string;

    let markersMap : Map<string, { marker: google.maps.Marker, infoWindow: google.maps.InfoWindow }> = new Map();
    let currentInfoWindow : google.maps.InfoWindow | null = null;
    let map : google.maps.Map;
    let mapElement : HTMLElement;
    let circle : google.maps.Circle;

    $: if (circle) circle.setRadius(distance);

    $: addVehiculeMarkers(vehicles, map, bookedCar);

    onMount(async () => {
        initMap();
    });

    function initMap() {
        const baseZoom = 19
        const zoom = baseZoom - Math.log2(distance / 50);
        map = new google.maps.Map(mapElement, {
            center: center,
            zoom: zoom,
            disableDefaultUI: true
        });
        const centerMarker = new google.maps.Marker({
            map: map,
            position: center
        });
        centerMarker.setIcon('https://maps.google.com/mapfiles/ms/icons/green-dot.png');
        drawCircle();
    }

    function drawCircle() {
        circle = new google.maps.Circle({
            strokeColor: '#FF0000',
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: '#FF0000',
            fillOpacity: 0.35,
            map: map,
            center: center,
            radius: distance
        });
    }

    function addVehiculeMarkers(vehicles, map, bookedCar) {
        if (!map) return;

        const allVehicles = bookedCar ? [...vehicles, bookedCar] : [...vehicles];
        const newIds = new Set(allVehicles.map(v => String(v.data.Id)));

        // Remove markers for vehicles no longer in the list
        for (const [id, { marker, infoWindow }] of markersMap) {
            if (!newIds.has(id)) {
                if (currentInfoWindow === infoWindow) {
                    currentInfoWindow.close();
                    currentInfoWindow = null;
                }
                marker.setMap(null);
                markersMap.delete(id);
            }
        }

        // Add markers only for new vehicles
        allVehicles.forEach(function(elem) {
            const id = String(elem.data.Id);
            if (markersMap.has(id)) {
                // Update icon/animation in case state changed (e.g. good → booked)
                const { marker } = markersMap.get(id);
                if (elem.booked) {
                    marker.setIcon('https://maps.google.com/mapfiles/ms/icons/yellow-dot.png');
                    marker.setAnimation(null);
                } else if (elem.good) {
                    marker.setIcon('https://maps.google.com/mapfiles/ms/icons/blue-dot.png');
                    marker.setAnimation(google.maps.Animation.BOUNCE);
                } else {
                    marker.setIcon('https://maps.google.com/mapfiles/ms/icons/red-dot.png');
                    marker.setAnimation(null);
                }
                return;
            }

            const latlng = {
                lat: parseFloat(elem.coords.latitude),
                lng: parseFloat(elem.coords.longitude)
            };
            var marker = new google.maps.Marker({
                position: latlng,
                map: map
            });

            var infoWindow = new google.maps.InfoWindow({
                content: createInfoWindow(elem),
                maxWidth: 220
            });

            marker.addListener('click', function(){
                if (currentInfoWindow) {
                    currentInfoWindow.close();
                }
                currentInfoWindow = infoWindow;
                infoWindow.open(map, marker);
            });

            if (elem.booked) {
                marker.setIcon('https://maps.google.com/mapfiles/ms/icons/yellow-dot.png');
            } else if (elem.good) {
                marker.setIcon('https://maps.google.com/mapfiles/ms/icons/blue-dot.png');
                marker.setAnimation(google.maps.Animation.BOUNCE);
            } else {
                marker.setIcon('https://maps.google.com/mapfiles/ms/icons/red-dot.png');
            }

            markersMap.set(id, { marker, infoWindow });
        });
    }

    function createInfoWindow(voiture) {
        var resultat =
        '<div><b>'+
            (language == "FR" ? 'Voiture ' : "Car ") + voiture.data.Name + ' ' + voiture.data.ModelName + '</b><br/>' +
            'Distance : ' + voiture.distance + (language == "FR" ? ' mètres' : " meters") + '<br/>' +
            (voiture.energy != null ? (language == "FR" ? 'Batterie : ' : 'Battery: ') + voiture.energy + '%' : '') +
            '</div>';
        return resultat;
    }

    </script>

    <style>
        .map-container {
            height: 100%;
            width: 100%;
            min-height: 400px;
        }
    </style>

    <div bind:this={mapElement} class="map-container"></div>
